<template>
    <div>
      <div class="home-header">
        <div class="left logo">
          <a href="/platform.html" class="left link">
            <img src="/images/platform/forun_zhiyun/header_logo.png" alt="" style="width: 80%;">
          </a>
        </div>
        <div class="right nav-cont zhongmian" style="margin-top: 30px;">
          <a class="nav-links" :class="{ active: isActive('/index') }" target="_blank" href="/platform.html">首页</a>
          <template v-if="!userName">
             <a class="nav-links" :class="{ active: isActive('/sourceOfGoods') }" href="/platform.html#/sourceOfGoods?type=1">货源广场</a>
            <a class="nav-links" :class="{ active: isActive('/sourceOfVehicleSource') }" href="/platform.html#/sourceOfVehicleSource?type=1">运力广场</a>
          </template>
          <template v-else>
            <a class="nav-links" href="/platform.html#/sourceOfGoods?type=1">货源广场</a>
            <a class="nav-links" target="_blank" href="/platform.html#/sourceOfVehicleSource?type=1">运力广场</a>
            <!-- <a v-if="isOnline" class="nav-links" :href="'https://scm.zczy56.com/group/#/emptyPage?zhongmian=true&token=' + tokenId" target="_blank">智慧运营</a>
            <a v-else class="nav-links" :href="'http://supply-chain-group.zczy.com/#/emptyPage?zhongmian=true&token=' + tokenId" target="_blank">智慧运营</a> -->
          </template>
          <div class="login-info">
            <a  v-if="!userName" href="/consignor.html#/login" class="login-btn">
            <img class="denglu-icon" src="/images/platform/zaozhuang_zhiyun/denglu.png" alt="">
            </a>
            <div v-else class="logined-div">
              <div class="logined-head">
                <i class="el-icon-s-custom user-icon"></i>
                <i class="el-icon-caret-bottom arrow-icon"></i>
              </div>
              <div class="logined-slide">
                <a class="slide-link" href="/consignor.html#/publicPage/myFortune">您好：{{ userName }}</a>
                <a class="slide-link" href="/consignor.html#/publicPage/myFortune">个人中心</a>
                <a class="slide-link" href="javascript:;" @click="memberExit">退出</a>
              </div>
            </div>
          </div>
          
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </template>
  <script>
  import { loginService } from '@/services/login';
  export default {
    data(){
      let tokenId = localStorage.getItem('tokenId');
      return {
        userName:'',
        isOnline: false,
        tokenId
      }
    },
    created(){
      this.userName = localStorage.getItem('userName')
      if(location.origin.indexOf('172') !== -1 || location.origin.indexOf('pre') !== -1){
        this.isOnline = false;
      }else {
        this.isOnline = true;
      }
    },
    methods:{
        isActive(path) {
        // 判断当前路由是否与给定路径匹配
        return this.$route.path.includes(path);
      },
      async gotoJth(){
        if(this.tokenId){
          let tempRes = await loginService.getTempToken({
            sessionId: this.tokenId
          })
          if(this.isOnline){
            window.open('https://scm.zczy56.com/group/#/emptyPage?zhongmian=true&token=' + (tempRes.data || this.tokenId))
          }else {
            window.open('http://supply-chain-group.zczy.com/#/emptyPage?zhongmian=true&token=' + (tempRes.data || this.tokenId))
          }
        }else {
          if(this.isOnline){
            window.open('https://scm.zczy56.com/group/#/login?zhongmian=true')
          }else {
            window.open('http://supply-chain-group.zczy.com/#/login?zhongmian=true')
          }
        }
        
      },
      memberExit(){
        axios.get('/whale-aio-sso-server/app/logout', {
          params: {
            sessionId:this.tokenId
          }
        })
        .then(function(res){
          if(res && res.code === '200') {
  
          }
          localStorage.clear()
          window.location.href = '/';
        }).catch(function(err){
          localStorage.clear()
          window.location.href = '/';
        })
      }
    }
  }
  </script>
  <style lang="stylus" scoped>
  .denglu-icon{
    width: 80px;
    position relative
    top 10px
  }
  .home-header
    position fixed
    top 0
    z-index 999
    height 110px
    background #fff
    width 100%
    padding-top 10px
    box-sizing border-box
    height: 8vh
    min-width: 1500px;
    .zhongmian {
      display: flex
      align-items: flex-end
      margin-right 15%
    }
    .logo
      margin-left 15%
     
    .nav-links
      padding-left 15px
      padding-right 15px
      color #666666
      padding-bottom: 23px;
      .link 
        line-height 64px
        font-size 14px
        // color #333
        padding 0 30px
    .login-info
      margin-right 48px
      .login-btn 
        display inline-block
        line-height 64px
        padding-left 26px
        position relative
        i
          position absolute
          font-size 20px
          left 0
          top 22px
      .logined-div
        position relative
        .logined-head
          line-height 64px
          position relative
          padding-right 20px
          .user-icon
            font-size 20px
          .arrow-icon
            position absolute
            right 0 
            top 50%
            margin-top -7px
            transform-origin center center
            transition transform .4s
        .logined-slide
          display none 
          position absolute
          width: 130px
          background: #fff
          right 0
          top 60px
          .slide-link
            display: block
            line-height 32px
            padding 0 16px
      .logined-div:hover
        z-index 99
        .logined-slide
          display inline-block
        .arrow-icon
          transform rotate(180deg)
   .active {
       padding-bottom: 15px !important;;
        border-bottom: 8px solid #338BE8;
        color: #333 !important;
      } 
    .header_img{
      margin-top: 10px;
      margin-left: 20px;
    }         
  </style>